module.exports = __webpack_public_path__ + "img/icon_10.630a2cae.png";